import { render, staticRenderFns } from "./DescriptionEditor.vue?vue&type=template&id=7fd54c19&scoped=true&"
import script from "./DescriptionEditor.vue?vue&type=script&lang=js&"
export * from "./DescriptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionEditor.vue?vue&type=style&index=0&id=7fd54c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd54c19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
